import React, { useState, useEffect } from "react";
import { PartyInfoFilterContainer } from "../../../PartyInfo/PartyInfoFilter";
import LineBtn from "../../../../../Button/LineBtn";
import MatchMakingEmailInputModal from "./N_MatchMakingEmailInputModal";
import Flex from "../../../../../DefaultStyles/Flex";
import DropDown, { OptionType } from "../../../../../Filters/DropDown";
import ConfirmBtn from "../../../../../Button/ConfirmBtn";
import {
  getMatchMakingSubsOptionList,
  getN_MatchMakingSubsOptionList,
} from "../../../../../../AdminApi/commFunc";
import { atom, useRecoilState } from "recoil";
import Search from "../../../../../Filters/Search";

export const matchMakingEmailFilter = atom({
  key: "matchMakingEmailFilter",
  default: {
    subsId: "",
    using: "",
    searchValue: "",
    searchComment: "",
    page: 0,
  },
});

interface MatchMakingEmailFilterProps {
  refetch: () => void;
}

export default function MatchMakingEmailFilter({
  refetch,
}: MatchMakingEmailFilterProps) {
  const usingOptionList = [
    { value: "all", label: "전체" },
    { value: "1", label: "사용 중" },
    { value: "0", label: "미사용" },
  ];

  const subsOptionList = getN_MatchMakingSubsOptionList();

  const [filter, setFilter] = useRecoilState(matchMakingEmailFilter);
  const [searchValue, setSearchValue] = useState<string | undefined>(
    filter?.searchValue !== "" ? filter?.searchValue : ""
  );
  const [emailModal, setEmailModal] = useState(false);
  const [using, setUsing] = useState<OptionType>({
    value: filter?.using !== "" ? filter?.using : "",
    label:
      filter?.using !== ""
        ? usingOptionList?.find((f) => f.value === filter?.using)?.label
        : "사용 여부 선택",
  });
  const [subscription, setSubscription] = useState<OptionType>({
    value: filter?.subsId !== "" ? filter?.subsId : "",
    label:
      filter?.subsId !== ""
        ? subsOptionList?.find((s) => s.value === filter?.subsId)?.label
        : "Subscription 선택",
  });

  useEffect(() => {
    if (searchValue && searchValue?.length > 0) {
      setFilter((prev) => ({
        ...prev,
        searchValue: `${searchValue}`,
      }));
    }
  }, [searchValue]);

  return (
    <>
      <PartyInfoFilterContainer>
        <LineBtn
          btnText="뉴 매치메이킹 이메일 추가"
          icon="add"
          btnHeight={38}
          btnClickEvent={() => setEmailModal(true)}
        />
      </PartyInfoFilterContainer>

      <PartyInfoFilterContainer>
        <Flex>
          <Search placeholder="이메일 입력" setSearchValue={setSearchValue} />
        </Flex>

        <Flex gapSize={10}>
          <DropDown
            dropdownValue={using}
            setDropDownValue={setUsing}
            boxWidth={150}
            optionList={usingOptionList}
          />

          <DropDown
            dropdownValue={subscription}
            setDropDownValue={setSubscription}
            boxWidth={190}
            optionList={subsOptionList}
          />

          <ConfirmBtn
            btnText="적용"
            btnColor="mint"
            isDisabled={using?.value === "" && subscription?.value === ""}
            btnClickEvent={() => {
              setFilter((prev) => ({
                ...prev,
                subsId: subscription?.value ?? "",
                using: using?.value ?? "",
              }));
            }}
          />

          <LineBtn
            btnText="초기화"
            btnColor="mint"
            icon="refresh"
            btnHeight={38}
            disabled={using?.value === "" && subscription?.value === ""}
            btnClickEvent={() => {
              setUsing({
                value: "",
                label: "사용 여부 선택",
              });
              setSubscription({
                value: "",
                label: "Subscription 선택",
              });
              setFilter((prev) => ({
                ...prev,
                subsId: "",
                using: "",
              }));
            }}
          />
        </Flex>
      </PartyInfoFilterContainer>

      {emailModal && (
        <MatchMakingEmailInputModal
          refetch={refetch}
          closeEvent={() => setEmailModal(false)}
        />
      )}
    </>
  );
}
